import { Button, Form, Modal, Select } from 'antd';
import { useForm, useSelect } from '@refinedev/antd';
import type { HttpError, useModalReturnType } from '@refinedev/core';
import type { IAgent } from 'interfaces/agents';

interface AddManagerModalModalProps {
  modal: useModalReturnType;
  loading: boolean;
  classroomId: string;
  onSubmit: (agentId: string) => void;
}

interface FormData {
  agentId: string;
}

export const AddManagerModal = ({
  modal,
  loading,
  classroomId,
  onSubmit
}: AddManagerModalModalProps) => {
  const { form, formProps } = useForm<FormData, HttpError, FormData>();

  const { selectProps } = useSelect<IAgent>({
    resource: `classrooms/${classroomId}/managers/available`,
    optionLabel: 'name',
    optionValue: 'id',
    fetchSize: 50,

    onSearch: value => [
      {
        field: 'filter[by_name]',
        operator: 'eq',
        value: value
      }
    ],

    pagination: {
      mode: 'server'
    }
  });

  return (
    <Modal
      title="Adicionar docente à equipe da turma"
      open={modal.visible}
      onCancel={modal.close}
      destroyOnClose
      footer={[
        <Button key="back" onClick={() => modal.close()}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          onClick={form.submit}
          loading={loading}
          disabled={loading}
        >
          Adicionar docente
        </Button>
      ]}
    >
      <Form
        {...formProps}
        layout="vertical"
        onFinish={({ agentId }) => onSubmit(agentId)}
      >
        <Form.Item label="Usuário" name="agentId">
          <Select {...selectProps} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
